import './home.css';
import { Container } from '@mui/material';
import React from 'react'

function NeuAnmelden() {

    return (
        <Container maxWidth="lg">
          
                Bitte öffnen Sie den Link zur Ihrer Kundenakte erneut.
           
        </Container>
    )
}

export default NeuAnmelden